import { Controller } from "react-hook-form";
import type { Control, FieldValues } from "react-hook-form";
import { BpaPickerField } from "./BpaPickerField";
import styles from "../../CmsCreateBpaPage.module.css";
import shared from "../cmsShared.module.css";

type BpaEditionLinkFieldsProps<T extends FieldValues = FieldValues> = {
  control: Control<T>;
  previousEditionId: string | null;
  editionId: string;
  editionNamesByEditionId?: Map<string, string>;
};

export function BpaEditionLinkFields<T extends FieldValues = FieldValues>({
  control,
  previousEditionId,
  editionId,
  editionNamesByEditionId,
}: BpaEditionLinkFieldsProps<T>) {
  return (
    <section className={shared.sectionCard}>
      <h2 className={shared.sectionHeading}>Edition links</h2>
      <div className={styles.fieldRow}>
        <div className={styles.field}>
          <Controller
            name={"previousEditionBpaId" as never}
            control={control}
            render={({ field }) => (
              <BpaPickerField
                label="Previous edition BPA"
                editionId={previousEditionId}
                editionNamesByEditionId={editionNamesByEditionId}
                value={field.value as string | null}
                onChange={val => field.onChange(val)}
                disabled={!previousEditionId}
                disabledPlaceholder="No previous edition"
                helperText="The practice area this one was carried forward from in the previous edition. Used to track renames across editions."
              />
            )}
          />
        </div>
        <div className={styles.field}>
          <Controller
            name={"sourceEditionBpaId" as never}
            control={control}
            render={({ field }) => (
              <BpaPickerField
                label="Source edition BPA"
                editionId={editionId}
                editionNamesByEditionId={editionNamesByEditionId}
                value={field.value as string | null}
                onChange={val => field.onChange(val)}
                helperText="The practice area this one was copied from, e.g. when splitting a practice area or creating a translated edition."
              />
            )}
          />
        </div>
      </div>
    </section>
  );
}
